/**
 * CSS zoom applied to an analysis page while the PDF export captures it. Chrome prints 1 CSS px
 * as 0.75pt, so this takes 12px body text to ~10pt on the page. Kept small on purpose: the report
 * lays out in 1600 / zoom CSS px, and anything wider than the page is either cut or makes Chrome
 * shrink the whole PDF. The export's puppeteer deviceScaleFactor is scaled by it too.
 */
export const ANALYSIS_SNAPSHOT_ZOOM = 1.12
